/**
 * Lucide icons for Status page (campaigns/teams). Used by Status sidebar and Settings > Status icons.
 * See https://lucide.dev/icons/
 */

export const DEFAULT_CAMPAIGNS = ['Inbound', 'Outbound', 'Retention', 'Technical', 'General'];
export const DEFAULT_TEAMS = ['Support', 'Sales', 'Development', 'Help Desk', 'Marketing', 'Operations'];
import {
  LayoutList,
  PhoneIncoming,
  PhoneOutgoing,
  Headphones,
  Users,
  Building2,
  Target,
  Folder,
  List,
  Mail,
  MessageCircle,
  Phone,
  Zap,
  Briefcase,
  Calendar,
  CircleUser,
  Shield,
  Star,
  Landmark,
  Factory,
  FileText,
  BookOpen,
  GraduationCap,
  Stethoscope,
  Scale,
  UtensilsCrossed,
  Bot,
  Cpu,
  Database,
  Server,
  Cloud,
  MessageSquare,
  Heart,
  Award,
  TrendingUp,
  BarChart3,
  Wallet,
  Package,
  PhoneOff,
  type LucideIcon,
} from 'lucide-react';

/** To add more icons: add import from 'lucide-react', add to this array and to iconMap below. */
export const STATUS_ICON_OPTIONS: { value: string; label: string }[] = [
  { value: 'LayoutList', label: 'List' },
  { value: 'List', label: 'List (alt)' },
  { value: 'Folder', label: 'Folder' },
  { value: 'PhoneIncoming', label: 'Phone Incoming' },
  { value: 'PhoneOutgoing', label: 'Phone Outgoing' },
  { value: 'Phone', label: 'Phone' },
  { value: 'Headphones', label: 'Headphones' },
  { value: 'Users', label: 'Users' },
  { value: 'Building2', label: 'Building' },
  { value: 'Target', label: 'Target' },
  { value: 'Mail', label: 'Mail' },
  { value: 'MessageCircle', label: 'Message' },
  { value: 'Zap', label: 'Zap' },
  { value: 'Briefcase', label: 'Briefcase' },
  { value: 'Calendar', label: 'Calendar' },
  { value: 'CircleUser', label: 'User' },
  { value: 'Shield', label: 'Shield' },
  { value: 'Star', label: 'Star' },
  { value: 'Landmark', label: 'Landmark' },
  { value: 'Factory', label: 'Factory' },
  { value: 'FileText', label: 'File / Doc' },
  { value: 'BookOpen', label: 'Book' },
  { value: 'GraduationCap', label: 'Education' },
  { value: 'Stethoscope', label: 'Healthcare' },
  { value: 'Scale', label: 'Legal' },
  { value: 'UtensilsCrossed', label: 'Hospitality' },
  { value: 'Bot', label: 'Bot / AI' },
  { value: 'Cpu', label: 'Tech' },
  { value: 'Database', label: 'Database' },
  { value: 'Server', label: 'Server' },
  { value: 'Cloud', label: 'Cloud' },
  { value: 'MessageSquare', label: 'Chat' },
  { value: 'Heart', label: 'Care' },
  { value: 'Award', label: 'Award' },
  { value: 'TrendingUp', label: 'Growth' },
  { value: 'BarChart3', label: 'Analytics' },
  { value: 'Wallet', label: 'Finance' },
  { value: 'Package', label: 'Logistics' },
  { value: 'PhoneOff', label: 'Phone Off / Abandoned' },
];

const iconMap: Record<string, LucideIcon> = {
  LayoutList,
  List,
  Folder,
  PhoneIncoming,
  PhoneOutgoing,
  Phone,
  Headphones,
  Users,
  Building2,
  Target,
  Mail,
  MessageCircle,
  Zap,
  Briefcase,
  Calendar,
  CircleUser,
  Shield,
  Star,
  Landmark,
  Factory,
  FileText,
  BookOpen,
  GraduationCap,
  Stethoscope,
  Scale,
  UtensilsCrossed,
  Bot,
  Cpu,
  Database,
  Server,
  Cloud,
  MessageSquare,
  Heart,
  Award,
  TrendingUp,
  BarChart3,
  Wallet,
  Package,
  PhoneOff,
};

export function getStatusIcon(name: string | undefined): LucideIcon {
  if (!name || !iconMap[name]) return LayoutList;
  return iconMap[name];
}
